// AUTO-GENERATED from docs/docs/fastlane/user-support/fastlane-user-manual-combined.md.
// Do not edit by hand. Re-run scripts/generate-user-guide-sections.py.


import { CheckCircleOutlined } from "@ant-design/icons";
import type { Section } from "../../types";
import img1 from "../../images/main/quality-gages/quality-gages.png";

export const quality_gagesSection: Section = {
	key: "quality-gages",
	label: "Maintaining the Gage Repository",
	icon: CheckCircleOutlined,
	intro: "This is the Quality Lead's home base. Every measuring instrument the shop uses lives here, with calibration date, current location, and assignment to a job.",
	blocks: [
		{ type: "heading", level: 3, text: "9.1 Browsing the Gage List" },
		{ type: "image", src: img1, alt: "Quality Gages" },
		{ type: "paragraph", text: "Use this when you need to find a specific gage, check whether one is due for calibration, or see who has it checked out. Filters across the top let you narrow by category, calibration status, and location." },
		{ type: "heading", level: 3, text: "9.X Troubleshooting Gages" },
		{ type: "paragraph", text: "TODO: pending input from Quality Lead on common pitfalls (lost gages, expired calibration, wrong-location records)." },
	],
};

export default quality_gagesSection;
